import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // browser language detection options
    supportedLngs: ["en", "fr"],
    detection: {
      order: ["navigator"],
      caches: [], // // Very important: disable caching so the detected language is not stored in browser storage
    },

    // i18next options
    fallbackLng: "fr",
    defaultNS: "translation",
    ns: ["translation"],
    resources: {
      fr: {
        translation: fr,
      },
      en: {
        translation: en,
      },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format(value, format, lng) {
        // Custom formatter for {{ myDate, datetime }}
        if (format === "datetime" && value instanceof Date) {
          return new Intl.DateTimeFormat(lng, {
            day: "numeric",
            month: "long",
            year: "numeric",
          }).format(value);
        }
        return value;
      },
    },
  });
